require('./inc/site.js');
require('./inc/jquery.validationEngine.js');
require('./inc/jquery.validationEngine-hu.js');

var copyChk = undefined;
var shippingSection = undefined;

$(document).ready(function(){
  copyChk = $('[data-purpose="copy-checkbox"]');
  shippingSection = $('[data-purpose="shipping-address-container"]');

  if (copyChk.length == 1 && shippingSection.length == 1) {
    copyChk.change(function() {
      var copy = $(this).prop('checked');

      if (copy) {
        shippingSection.slideUp(300);
      } else {
        shippingSection.slideDown(300);
      }
    });
  }
  
	$('[data-purpose = "postcode"]').change(function() {
		var pcode = $(this).val();
		var irsz = $(this).closest('.two-col-row').find($('[data-purpose="city"]'));
		var request;
		if (request) {
			request.abort();
		}
		var request = $.ajax({
			url: "ajax/postcode.php",
			type: "post",
			data: {pcode: pcode},
			dataType: "json"
		});
		request.done(function (data){
			if (data['ok'] == "true") {
				irsz.val(data['telepules']);
			}
		});
	})
	
});
